import { createStore } from 'vuex'
import { getMenuTree } from '@/views/Login/api.js'
import storage from '@/utiles/store'
import { cloneDeep } from 'lodash';
import router from '../router/index'
import primariesRoutes from '../router/promisse'
const { getCache, setCache } = storage
interface pageQuery{
  key:string,
  value:any
}
export default createStore({
  state: {
    menu: getCache(
      'menu',
      false
    ) || [],
    menuTee:getCache(
      'menuTree'
    ) || [],
    userInfo:getCache(
      'userInfo',
      false
    ),
    insur:{
      collectQuery:{},
      auditQuery:{},
      auditedQuery:{},
    },
    claim:{
      collectQuery:{},
      auditQuery:{},
      auditedQuery:{},
    },
    auditNum: getCache('auditNum', false) || { caseAuditNum: 0, orderAuditNum: 0 }, // 初始值为一个对象
  },
  getters: {
    menu: state => state.menu,
    menuTree: state => state.menuTee,
    auditNum: (state) => state.auditNum,
    caseAuditNum: (state) => state.auditNum.caseAuditNum,
    orderAuditNum: (state) => state.auditNum.orderAuditNum,
  },
  mutations: {
    SET_MENU: (state, params = {}) => {
      let { menu } = params;
      state.menu = menu
      setCache('menu', menu, false)
    },
    SET_MENUTREE :(state, params = {}) => {
      let { menu } = params;
      state.menuTee = menu
      setCache('menuTree', menu, true)
    },
    SET_USERINFO :(state , params = {})=>{
      state.userInfo = params
      setCache('userInfo', params, false)
    },
    SET_COLLECT :(state , params) =>{
      // let { key , value}
      // state[key] = value
    },
    SET_AUDITNUM: (state, params) => { // 更新auditNum对象  
      if (params.caseAuditNum !== undefined) {  
        state.auditNum.caseAuditNum = params.caseAuditNum;  
      }  
      if (params.orderAuditNum !== undefined) {  
        state.auditNum.orderAuditNum = params.orderAuditNum;  
      }  
      setCache('auditNum', state.auditNum, false);  
    },  
  },
  actions: {
   
    // 获取系统菜单
    GetMenu({ commit }, obj) {
      return new Promise(resolve => {
        getMenuTree().then((res: any) => {
          let userInfo = sessionStorage.getItem("userInfo")
          ? JSON.parse(sessionStorage.getItem("userInfo") || "")
          : "";
          let data = cloneDeep(res); // 确保你已经从lodash导入了cloneDeep  
        
          // 分别获取id为'1'和'2'的菜单项  
          let menu1 = data.find((v: any) => v.id == '1');  
          let menu2 = data.find((v: any) => v.id == '2');  
            
          // 仅在找到menu2并且userInfo.id不为'0'时过滤children  
          if (menu2 && userInfo.id !== '0') {  
            menu2.children = menu2.children?.filter((m: any) => m.id !== '0') || [];  
          }  
            
          // 构建最终要提交的菜单树  
          let menuTree = [menu1, menu2].filter(Boolean); // 过滤掉未找到的菜单项（undefined或null）  
            
          
          commit('SET_MENUTREE', { menu:menuTree })
          resolve(menuTree)
        })
      })
    },
  
  },
  modules: {
  }
})
